var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"income-breakdown-container",staticClass:"income-breakdown-container"})}
var staticRenderFns = []

export { render, staticRenderFns }